import { numberWithCommas, numberWithPeriods } from '../../Utils/Utils.js';

const Counters = (domEl) => {

	// Get all counters
	const counters = domEl.querySelectorAll('.counter');

	// Observe the counters so we won't start 'em before they enter the view
	let observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {

				if(entry.isIntersecting) {
					entry.target.classList.add('js-in-view-initialized');

					animateValue(
						entry.target.querySelector('.number .the-number'),
						entry.target.querySelector('.number .suffix'),
						parseFloat(entry.target.getAttribute('data-from')),
						parseFloat(entry.target.getAttribute('data-to')),
						parseFloat(entry.target.getAttribute('data-duration')),
						entry.target.getAttribute('data-delimiter'),
						entry.target.getAttribute('data-suffix'),
					);

					observer.unobserve(entry.target);
				}
			});
		},
		{rootMargin: "0px 0px -50px 0px"});


	const animateValue = (obj, suffixObj, start, end, duration, delimiter, suffix) => {

		let startTimestamp = null;
		const step = (timestamp) => {
			if(!startTimestamp) startTimestamp = timestamp;
			const progress = Math.min((timestamp - startTimestamp) / duration, 1);
			const newValue = Math.floor(progress * (end - start) + start);
			if(delimiter === 'period') {
				obj.innerHTML = `${numberWithPeriods(newValue)}`;
			}
			else if(delimiter === 'comma') {
				obj.innerHTML = `${numberWithCommas(newValue)}`;
			}
			else {
				obj.innerHTML = `${newValue}`;
			}

			if(progress < 1) {
				window.requestAnimationFrame(step);
			}
			else {
				suffixObj.classList.add('js-visible');
			}
		};
		window.requestAnimationFrame(step);
	};

	// Set a small timeout so the dom elements have time to get to their starting position before coming into .in-view position
	setTimeout(() => {
		counters.forEach((counter) => {
			observer.observe(counter);
		});
	}, 100);
};

export default Counters;